
import React from 'react';
import { Globe, MessageCircle, Phone, Mail, Instagram, Facebook, MapPin, QrCode, Map } from 'lucide-react';
import QRCodeGenerator from '../common/QRCodeGenerator';
import MapComponent from '../common/MapComponent';

const TechLinktree = () => {
  const socialLinks = [
    { icon: Instagram, url: "https://www.instagram.com/decidedigitaloficial", label: "Instagram" },
    { icon: Facebook, url: "https://www.facebook.com/decidedigitaloficial", label: "Facebook" },
  ];

  const mainLinks = [
    {
      icon: Globe,
      title: "Visite nosso website",
      subtitle: "Conheça nossas soluções digitais",
      url: "https://decidedigital.com.br/",
      gradient: "from-blue-500 to-purple-600"
    },
    {
      icon: MessageCircle,
      title: "WhatsApp",
      subtitle: "Fale conosco agora",
      url: "https://wa.me/5569992083972?text=Ol%C3%A1%20eu%20gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20as%20solu%C3%A7%C3%B5es%20da%20Decide%20Digital!",
      gradient: "from-green-500 to-emerald-600"
    },
    {
      icon: Phone,
      title: "Telefone",
      subtitle: "+55 (69) 99208-3972",
      url: "tel:+5569992083972",
      gradient: "from-indigo-500 to-blue-600"
    },
    {
      icon: Mail,
      title: "E-mail",
      subtitle: "contato@decidedigital.com.br",
      url: "mailto:contato@decidedigital.com.br",
      gradient: "from-purple-500 to-pink-600"
    },
    {
      icon: MapPin,
      title: "Nossa Localização",
      subtitle: "Veja onde estamos",
      url: "https://maps.app.goo.gl/67vmppvo3ERddDZQ9",
      gradient: "from-red-500 to-orange-600"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-900 py-8 px-4">
      <div className="max-w-md mx-auto">
        {/* Profile Section */}
        <div className="text-center mb-8 animate-fade-in">
          <div className="w-24 h-24 mx-auto mb-4 bg-gradient-to-br from-blue-400 to-purple-600 rounded-full flex items-center justify-center shadow-2xl">
            <span className="text-3xl font-bold text-white">DD</span>
          </div>
          <h1 className="text-2xl font-bold text-white mb-2">Decide Digital</h1>
          <p className="text-gray-300 leading-relaxed px-4">
            Agência digital especializada em soluções inovadoras para produtos, comércio e SaaS. 
            Transformamos ideias em realidade digital.
          </p>
        </div>

        {/* QR Code Section */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 mb-6 text-center animate-scale-in">
          <div className="flex items-center justify-center gap-2 mb-3">
            <QrCode className="w-4 h-4 text-white" />
            <p className="text-white text-sm">Acesse nosso site:</p>
          </div>
          <div className="flex justify-center">
            <QRCodeGenerator url="https://decidedigital.com.br/" size={100} />
          </div>
        </div>

        {/* Social Icons */}
        <div className="flex justify-center space-x-4 mb-8">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-all duration-300 hover:scale-110 animate-scale-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <social.icon className="w-5 h-5 text-white" />
            </a>
          ))}
        </div>

        {/* Main Links */}
        <div className="space-y-4">
          {mainLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`block w-full p-4 bg-gradient-to-r ${link.gradient} rounded-2xl text-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 animate-fade-in`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex items-center">
                <link.icon className="w-6 h-6 mr-4" />
                <div className="flex-1">
                  <div className="font-semibold">{link.title}</div>
                  <div className="text-sm opacity-90">{link.subtitle}</div>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Interactive Map */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 mt-6 animate-fade-in">
          <div className="flex items-center justify-center gap-2 mb-3">
            <Map className="w-4 h-4 text-white" />
            <p className="text-white text-sm">Nossa localização:</p>
          </div>
          <MapComponent latitude={-8.7619} longitude={-63.9019} zoom={15} />
        </div>

        {/* Footer */}
        <div className="text-center mt-8 animate-fade-in">
          <p className="text-white/60 text-sm">
            © 2024 Decide Digital - Inovação em cada clique
          </p>
        </div>
      </div>
    </div>
  );
};

export default TechLinktree;
